<template>
  <div style="cursor: help;" @click="$emit('clicked')" title="Edit your quick search">
    <div v-if="query.isRemortgage()">
      <p class="text-white summary">
        {{ isExample ? "Example" : "Your" }} borrowing amount is <span class="text-warning inline-editable-field">{{ query.borrowingAmount() | prettyMoney }}</span>
        to be repaid over <span class="text-warning inline-editable-field">{{ query.term }} years</span>.
        {{ isExample ? "Loan" : "Your loan"}}-to-value (LTV) is <span class="text-warning inline-editable-field">{{ query.ltv() | prettyPercent }}</span>
        based on a property value of <span class="text-warning inline-editable-field">{{ query.propertyValue | prettyMoney }}</span>
        and a remaining balance of <span href="#" class="text-warning inline-editable-field">{{ query.remainingBalance | prettyMoney }}</span>.
        <i v-if="!noClick" class="fas fa-edit ml-2"></i>
      </p>
    </div>
    <div v-if="query.isFirstTimeBuyer()">
      <p class="text-white summary">
        Your borrowing amount is <span class="text-warning inline-editable-field">{{ query.borrowingAmount() | prettyMoney }}</span>
        to be repaid over <span class="text-warning inline-editable-field">{{ query.term }} years</span>.
        Your loan-to-value (LTV) is <span class="text-warning inline-editable-field">{{ query.ltv() | prettyPercent }}</span>
        based on a property value of <span class="text-warning inline-editable-field">{{ query.propertyValue | prettyMoney }}</span>
        and a deposit of <span href="#" class="text-warning inline-editable-field">{{ query.deposit | prettyMoney }}</span>.
        <i class="fas fa-edit ml-2"></i>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductQuerySummary",
  
  props: {
    query: Object,
    isExample: {
      type: Boolean,
      default: false
    },
    noClick: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.summary {
  font-size: large;
}
.inline-editable-field {
  font-weight: bold;
  cursor: help;
  border-bottom: dashed 1px;
}
</style>